module.exports = __webpack_public_path__ + "static/hire-session-cards-ef1be40b519a4764a0bb8d8ed1eecf1e.svg";